/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller } from "@hotwired/stimulus";

export default class AskForTOS extends Controller<HTMLAnchorElement> {
	getDialog() {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return document.getElementById("accept-tos") as HTMLDialogElement;
	}

	activate(e: MouseEvent) {
		if (!this.hasAcceptedTOS()) {
			e.preventDefault();
			this.getDialog().showModal();
		}
	}

	accepted() {
		this.element.click();
	}

	hasAcceptedTOS() {
		return localStorage.getItem("accepted-tos") == "true";
	}
}
